module.exports = {
  title: 'Something went wrong',
  link: {
    main: 'Return to main page',
  },
};
